import { useLocation } from 'wouter'
import { NewspaperIcon, GlobeAltIcon, UserGroupIcon } from '@heroicons/react/24/outline'
import { useUser } from '@/store/authStore'
import { cn } from '@/utils/cn'

const ITEMS = [
  { href: '/feed', label: 'Akış', Icon: NewspaperIcon },
  { href: '/arkadaslar', label: 'Arkadaşlar', Icon: UserGroupIcon },
  { href: '/student/kesfet', label: 'Keşfet', Icon: GlobeAltIcon }
]

export const SocialNavButtons = () => {
  const user = useUser()
  const [location, navigate] = useLocation()

  if (!user) return null

  return (
    <>
      {ITEMS.map(({ href, label, Icon }) => {
        const isActive = location === href
        return (
          <button
            key={href}
            type="button"
            onClick={() => navigate(href)}
            aria-label={label}
            className={cn(
              'flex items-center gap-1.5 px-2 py-2 rounded-full transition-colors',
              isActive ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100 text-gray-600'
            )}
          >
            <Icon className="w-6 h-6" />
            <span className="hidden md:inline text-sm font-medium">{label}</span>
          </button>
        )
      })}
    </>
  )
}
